<div class="row px-0 mx-0">
  <div class="q-select col-10 mx-0 px-0" [ngClass]="{'input-disabled':input.MainElementList[0].Disabled}">
    <select [id]="input.MainElementList[0].ID" Select (outData)="selectChange($event, input)">
      <option *ngFor="let option of input.MainElementList[0].SelectOptionsList; let i = index" [value]="option.Value" [selected]="option.Selected">{{option.Text}}</option>
    </select>
  </div>
  <div class="row col-2 px-0 mx-0 justify-content-center">

  </div>
</div>

<!--<select [id]="input.MainElementList[0].ID" class="select" Select [require]="input.MainElementList[0].Required" [disabled]="input.MainElementList[0].Disabled" [parent]="parent" [width]="100" [mode]="'bo'" (sendValue)="selectChange($event, input)">
  <option *ngFor="let option of input.MainElementList[0].SelectOptionsList; let i = index" [value]="option.Value" [selected]="option.Selected">{{option.Text}}</option>
</select>-->
